import React, { useState, useEffect } from 'react';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectList, saveProject } from '../../../../redux/projects/projectsActions';
import { Formik } from 'formik';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { useStyles } from '../../adminStyles';
import { DB_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../../../redux/constants';
import { Grid, Button, TextField, Typography ,Checkbox,FormControl,FormControlLabel} from '@material-ui/core';
import MileStoneList from './MileStoneList';

const newProject = {
  projectName: '',
  client: '',
  approvedAttachReq:0,
  startDate: null,
  endDate: null,
};

const ProjectRecord = props => {
  const dispatch = useDispatch();
  const projectList = useSelector(state => state.projects.allProjects);
  const { negativeBtn, approveBtn } = useStyles();
  const [selectedProject, setSelectedProject] = useState({});
  const [projectId, setProjectId] = useState(+props.match.params.pid);

  useEffect(() => {
    const getProjects = () => dispatch(getProjectList());
    getProjects();
    setProjectId(+props.match.params.pid);
  }, []);

  useEffect(() => {
    const getProject = () => {
      if (projectList.length) {
        let project = projectList.find(project => project.projectId === projectId)||{};
        let _milestones=project.milestones||[];
        if(_milestones.length===0){
          _milestones.push({milestoneId:'',descreption:''});
        }
        project.milestones=_milestones;
        setSelectedProject(project);
        return;
      }
    };
    getProject();
  }, [projectList]);

  const handleSubmit = async(values, projectId) => {
    const resp =await dispatch(saveProject(values, projectId));
     dispatch(getProjectList());
  };
  const addMileStone=()=>{
    const project={...selectedProject};
    project.milestones.push({milestoneId:'',descreption:''});
    setSelectedProject(project);
  }
  const delMileStone=(index)=>{
    const project={...selectedProject};
    project.milestones.splice(index, 1);
    if(project.milestones.length===0){
      project.milestones.push({milestoneId:'',descreption:''});
    }
    setSelectedProject(project);
  }
  const onChangeMileStoneText=(index,e)=>{
    const project={...selectedProject};
    project.milestones[index][e.target.name]=e.target.value;
    setSelectedProject(project);
  }

  return (
    <Formik
      enableReinitialize
      initialValues={projectId > 0 ? selectedProject : newProject}
      validate={values => {
        const errors = {};
        if (!values.projectName) {
          errors.projectName = 'Please enter project name.';
        }
        if (!values.client) {
          errors.client = 'Please enter client.';
        }
        if (!values.startDate) {
          errors.startDate = 'Please enter start date.';
        }
        if (!values.endDate) {
          errors.endDate = 'Please enter end date.';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);
          handleSubmit(values, projectId);
        }, 400);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  name='projectName'
                  variant='outlined'
                  helperText={touched.projectName ? errors.projectName : ''}
                  error={Boolean(errors.projectName)}
                  label='Project Name'
                  fullWidth
                  value={values.projectName}
                  onChange={handleChange}
                />
                {errors.projectName || touched.projectName || errors.projectName ? (
                  <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                  >
                    {errors.projectName}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={6}>
                <DatePicker
                  autoOk
                  fullWidth
                  inputVariant='outlined'
                  variant={'inline'}
                  label='Select project start date'
                  format={DISPLAY_DATE_FORMAT.replace('/DD/YYYY', '/dd/yyyy')}
                  value={
                    (values.startDate || null) === null
                      ? null
                      : moment(values.startDate, DB_DATE_FORMAT)._d
                  }
                  clearable={`true`}
                  error={Boolean(errors.startDate)}
                  onChange={e => {
                    if ((e || null) !== null) {
                      setFieldValue('startDate', moment(e).format(DB_DATE_FORMAT));
                    } else {
                      setFieldValue('startDate', null);
                    }
                  }}
                />
                {errors.startDate || touched.startDate || errors.startDate ? (
                  <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                  >
                    {errors.startDate}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={6}>
                <DatePicker
                  autoOk
                  fullWidth
                  inputVariant='outlined'
                  variant={'inline'}
                  label='Select project end date'
                  format={DISPLAY_DATE_FORMAT.replace('/DD/YYYY', '/dd/yyyy')}
                  value={
                    (values.endDate || null) === null
                      ? null
                      : moment(values.endDate, DB_DATE_FORMAT)._d
                  }
                  clearable={`true`}
                  error={Boolean(errors.endDate)}
                  onChange={e => {
                    if ((e || null) !== null) {
                      setFieldValue('endDate', moment(e).format(DB_DATE_FORMAT));
                    } else {
                      setFieldValue('endDate', null);
                    }
                  }}
                />
                {errors.endDate || touched.endDate || errors.endDate ? (
                  <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                  >
                    {errors.endDate}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name='client'
                  variant='outlined'
                  helperText={touched.client ? errors.client : ''}
                  error={Boolean(errors.client)}
                  label='Client'
                  fullWidth
                  value={values.client}
                  onChange={handleChange}
                />
                {errors.client || touched.client || errors.client ? (
                  <Typography
                    variant='caption'
                    display='block'
                    gutterBottom
                    color='error'
                  >
                    {errors.client}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={6}>
              <FormControlLabel
                  control={
                    <Checkbox
                    checked={values.approvedAttachReq === 1 ? true : false}
                      name='approvedAttachReq'
                      onChange={e => {
                        setFieldValue('approvedAttachReq',values.approvedAttachReq==1?0:1);
                      }}
                      color='primary'
                    />
                  }
                  label={'Client Timesheet Required'}
                />
                </Grid>
              <Grid item xs={10}>
                <MileStoneList data={selectedProject.milestones||[]} 
                  addMileStone={addMileStone} 
                  delMileStone={delMileStone} 
                  onChangeText={onChangeMileStoneText} />
              </Grid>
              
              <Grid item xs={12} container justify='flex-end'>
                <Button
                  type='button'
                  variant='raised'
                  color='primary'
                  className={negativeBtn}
                  onClick={() => {
                    props.history.push('/admin/projects');
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type='submit'
                  className={approveBtn}
                  variant='raised'
                  color='primary'
                  disabled={isSubmitting}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
        </form>
      )}
    </Formik>
  );
};
export default withRouter(ProjectRecord);
